<script>

import { updateCompare } from '../components/drawer.js';

export default {
  name: 'ProductCard',
  emits: [''],
  props: {
    product: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {}
  },
  methods: {
    handleCompare(e) {

      e.preventDefault();

      let compareList = JSON.parse(sessionStorage.getItem('compareList'));
      let productId = e.target.getAttribute('data-product-id');
      let compareCounts = document.getElementsByClassName('drawer-count');

      if ( compareList.indexOf( productId ) > -1 ) {
        //compareList = compareList.filter(item => item !== productId);
        //e.target.classList.remove('added-to-compare');
        //e.target.innerHTML = "Add to Compare";
      }

      if ( compareList.length > 2 && ! e.target.classList.contains('added-to-compare') ) {
        alert('You can only compare up to 3 products at a time.');
        return;
      }


      // is ID already in compare list?
      var index = compareList.indexOf(productId);
      if (index == -1) {
        compareList.push(productId);
        e.target.innerHTML = "Remove";
      } else {
        compareList.splice(index, 1);
        e.target.innerHTML = "Compare";
      }


      if (compareCounts.length > 0) {
        for (var i = 0; i < compareCounts.length; i++) {
          compareCounts[i].innerHTML = compareList.length;
        }
      }

      e.target.classList.toggle("added-to-compare");

      sessionStorage.setItem('compareList', JSON.stringify(compareList));

      // update compare count

      // var compareCounts = document.getElementsByClassName('drawer-count');


      // if not comparing already, open the drawer and put a timer on 

      if (  e.target.classList.contains('added-to-compare') ){
        var drawer = document.getElementById('compare-drawer');
        drawer.classList.add('open');

        setTimeout(function() {
          drawer.classList.remove('open');
        }, 5000);
      }


      // update the modal

      var data = {
        compareList: compareList
      };

      var tokenName = window.csrfTokenName;
      data[ tokenName ] = window.csrfTokenValue;

      $.ajax( {
        type: "post",
        data: data,
        url: '/actions/_mad-utilities/mad/do-something',
        success: function ( response ) {
          updateCompare(response);
        },
        error: function(e){
          console.log("ERROR");
          console.log(e);
        }
      });

    },
  },
  mounted() {

  }
}
</script>

<template>
  <div class="item-inner">
    <div class="item-title">
      <h3 class="sub-sm product-name">
        <span class="product-title">{{ product.title }}</span>
      </h3>
      <h4 class="sub-xxxs">{{ product.productCode }}</h4>
    </div>
    <div class="item-info">
      <div class="product-data">
        <div class="product-data-row list-col-one">
          <div class="data-name">SGN</div>
          <div class="data-entry product-sgn">{{ product.sgnSize }}</div>
        </div>
        <div class="product-data-row">
          <div class="data-name">Package Wt.</div>
          <div class="data-entry">
              <span class="product-weight">{{ product.packaging }}</span></div>
        </div>
        <div class="product-data-row list-col-two">
          <div class="data-name">Category</div>
          <div class="data-entry right grid-only"><span v-html="product.categoryStringSoft"></span></div>
          <div class="data-entry list-only"><span v-html="product.categoryString"></span></div>
        </div>
        <div v-if="product.activeIngredientsString.length>0" class="product-data-row list-col-two row-two">
          <div class="data-name">Active Ingredient(s)</div>
          <div class="data-entry right grid-only"><span v-html="product.activeIngredientsStringSoft"></span></div>
          <div class="data-entry list-only"><span v-html="product.activeIngredientsString"></span></div>
        </div>
      </div>
    </div>
    <div class="item-image">
      <figure>
        <img :src="product.transformedBagUrlSmall" :alt="product.title" width="300" height="375">
      </figure>
    </div>
    <div class="item-action">
      <div class="button-holder">
        <a v-bind:href="product.url" class="button sm">View</a>
        <a v-bind:data-product-id="product.id" @click="handleCompare" class="button compare sm default" :class="{ 'added-to-compare': product.addedToCompare }">Compare</a>
      </div>
      <div class="item-icons">
        <span v-if="product.usa" class="tooltip">
        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
            viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
          <circle style="fill:#F0F0F0;" cx="256" cy="256" r="256"/>
          <g>
            <path style="fill:#D80027;" d="M244.87,256H512c0-23.106-3.08-45.49-8.819-66.783H244.87V256z"/>
            <path style="fill:#D80027;" d="M244.87,122.435h229.556c-15.671-25.572-35.708-48.175-59.07-66.783H244.87V122.435z"/>
            <path style="fill:#D80027;" d="M256,512c60.249,0,115.626-20.824,159.356-55.652H96.644C140.374,491.176,195.751,512,256,512z"/>
            <path style="fill:#D80027;" d="M37.574,389.565h436.852c12.581-20.529,22.338-42.969,28.755-66.783H8.819
              C15.236,346.596,24.993,369.036,37.574,389.565z"/>
          </g>
          <path style="fill:#0052B4;" d="M118.584,39.978h23.329l-21.7,15.765l8.289,25.509l-21.699-15.765L85.104,81.252l7.16-22.037
            C73.158,75.13,56.412,93.776,42.612,114.552h7.475l-13.813,10.035c-2.152,3.59-4.216,7.237-6.194,10.938l6.596,20.301l-12.306-8.941
            c-3.059,6.481-5.857,13.108-8.372,19.873l7.267,22.368h26.822l-21.7,15.765l8.289,25.509l-21.699-15.765l-12.998,9.444
            C0.678,234.537,0,245.189,0,256h256c0-141.384,0-158.052,0-256C205.428,0,158.285,14.67,118.584,39.978z M128.502,230.4
            l-21.699-15.765L85.104,230.4l8.289-25.509l-21.7-15.765h26.822l8.288-25.509l8.288,25.509h26.822l-21.7,15.765L128.502,230.4z
            M120.213,130.317l8.289,25.509l-21.699-15.765l-21.699,15.765l8.289-25.509l-21.7-15.765h26.822l8.288-25.509l8.288,25.509h26.822
            L120.213,130.317z M220.328,230.4l-21.699-15.765L176.93,230.4l8.289-25.509l-21.7-15.765h26.822l8.288-25.509l8.288,25.509h26.822
            l-21.7,15.765L220.328,230.4z M212.039,130.317l8.289,25.509l-21.699-15.765l-21.699,15.765l8.289-25.509l-21.7-15.765h26.822
            l8.288-25.509l8.288,25.509h26.822L212.039,130.317z M212.039,55.743l8.289,25.509l-21.699-15.765L176.93,81.252l8.289-25.509
            l-21.7-15.765h26.822l8.288-25.509l8.288,25.509h26.822L212.039,55.743z"/>
          <g>
          </g>
          <g>
          </g>
          <g>
          </g>
          <g>
          </g>
          <g>
          </g>
          <g>
          </g>
          <g>
          </g>
          <g>
          </g>
          <g>
          </g>
          <g>
          </g>
          <g>
          </g>
          <g>
          </g>
          <g>
          </g>
          <g>
          </g>
          <g>
          </g>
          </svg>
          <span class="tooltiptext"><small>Available in USA</small></span>
        </span>
        <span v-if="product.can" class="tooltip">
          <svg fill="red" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M383.8 351.7c2.5-2.5 105.2-92.4 105.2-92.4l-17.5-7.5c-10-4.9-7.4-11.5-5-17.4 2.4-7.6 20.1-67.3 20.1-67.3s-47.7 10-57.7 12.5c-7.5 2.4-10-2.5-12.5-7.5s-15-32.4-15-32.4-52.6 59.9-55.1 62.3c-10 7.5-20.1 0-17.6-10 0-10 27.6-129.6 27.6-129.6s-30.1 17.4-40.1 22.4c-7.5 5-12.6 5-17.6-5C293.5 72.3 255.9 0 255.9 0s-37.5 72.3-42.5 79.8c-5 10-10 10-17.6 5-10-5-40.1-22.4-40.1-22.4S183.3 182 183.3 192c2.5 10-7.5 17.5-17.6 10-2.5-2.5-55.1-62.3-55.1-62.3S98.1 167 95.6 172s-5 9.9-12.5 7.5C73 177 25.4 167 25.4 167s17.6 59.7 20.1 67.3c2.4 6 5 12.5-5 17.4L23 259.3s102.6 89.9 105.2 92.4c5.1 5 10 7.5 5.1 22.5-5.1 15-10.1 35.1-10.1 35.1s95.2-20.1 105.3-22.6c8.7-.9 18.3 2.5 18.3 12.5S241 512 241 512h30s-5.8-102.7-5.8-112.8 9.5-13.4 18.4-12.5c10 2.5 105.2 22.6 105.2 22.6s-5-20.1-10-35.1 0-17.5 5-22.5z"/></svg>
          <span class="tooltiptext"><small>Available in Canada</small></span>
        </span>
        <span v-if="product.intl" class="tooltip">
          <svg fill="#597fe3" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25.2 25.2"><path d="m8.75,3.11l.49.86c.14.24.21.51.21.78v2.04c0,.19.08.38.21.51.31.31.81.28,1.08-.06l.67-.84c.23-.29.63-.38.96-.21l.75.37c.17.08.35.13.54.13.32,0,.63-.13.86-.35l.19-.19c.14-.14.36-.18.54-.09l1.44.72c.38.19.62.58.62,1.01,0,.52-.35.96-.85,1.09l-1.74.43c-.36.09-.74.07-1.1-.04l-1.57-.53c-.16-.05-.33-.08-.5-.08-.34,0-.68.11-.95.32l-1.92,1.46c-.5.37-.79.95-.79,1.58v1.38c0,1.3,1.06,2.36,2.36,2.36h1.57c.43,0,.79.35.79.79v2.36c0,.87.7,1.58,1.57,1.58.5,0,.96-.23,1.26-.63l1.26-1.68c.41-.55.63-1.21.63-1.89v-.6c0-.19.13-.36.31-.4l.26-.06c.59-.15,1-.67,1-1.28,0-.35-.14-.68-.38-.93l-1.65-1.65c-.18-.18-.18-.48,0-.66.28-.28.69-.38,1.07-.25l.69.23c.61.2,1.26-.07,1.55-.64.17-.34.55-.53.93-.45l1.35.27c-1.2-4.32-5.16-7.49-9.86-7.49-1.36,0-2.66.27-3.85.75ZM0,12.6C0,5.64,5.64,0,12.6,0s12.6,5.64,12.6,12.6-5.64,12.6-12.6,12.6S0,19.56,0,12.6Z"/></svg>
          <span class="tooltiptext"><small>Available Internationally</small></span>
        </span>
        <span v-if="product.featured" class="tooltip">
          <svg fill="#F7A800" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25.2 24.44"><path d="m13.97.86c-.25-.52-.79-.86-1.37-.86s-1.12.33-1.37.86l-3.07,6.31-6.85,1.01c-.57.09-1.05.49-1.23,1.04s-.03,1.15.38,1.56l4.97,4.92-1.17,6.95c-.1.57.14,1.15.62,1.49s1.1.38,1.61.11l6.12-3.27,6.12,3.27c.52.27,1.14.23,1.61-.11s.71-.92.62-1.49l-1.18-6.95,4.97-4.92c.41-.41.56-1.01.38-1.56s-.65-.95-1.23-1.04l-6.86-1.01L13.97.86Z"/></svg>
          <span class="tooltiptext"><small>Featured</small></span>
        </span>
        <span v-if="product.discontinued" class="tooltip">
          <svg fill="tan" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25.2 25.2"><path d="m12.6,0c6.96,0,12.6,5.64,12.6,12.6s-5.64,12.6-12.6,12.6S0,19.56,0,12.6,5.64,0,12.6,0Zm-1.18,5.91v6.69c0,.39.2.76.53.98l4.73,3.15c.54.36,1.27.22,1.64-.33s.22-1.27-.33-1.64l-4.2-2.8v-6.06c0-.65-.53-1.18-1.18-1.18s-1.18.53-1.18,1.18Z"/></svg>
          <span class="tooltiptext"><small>While Supplies Last</small></span>
        </span>
        <span v-if="product.aRewards" class="tooltip">
          <svg fill="green" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25.2 25.2"><path d="m9.38,3.39l1.71,2.91h-3.61c-1.09,0-1.97-.88-1.97-1.97s.88-1.97,1.97-1.97h.11c.73,0,1.42.39,1.79,1.02Zm-6.23.94c0,.71.17,1.38.47,1.97H1.58c-.87,0-1.58.7-1.58,1.58v3.15c0,.87.7,1.57,1.58,1.57h22.05c.87,0,1.58-.7,1.58-1.57v-3.15c0-.87-.7-1.58-1.58-1.58h-2.05c.3-.59.47-1.26.47-1.97,0-2.39-1.94-4.33-4.33-4.33h-.11c-1.57,0-3.03.83-3.82,2.19l-1.19,2.02-1.19-2.02c-.8-1.36-2.25-2.19-3.82-2.19h-.11C5.09,0,3.15,1.94,3.15,4.33Zm16.54,0c0,1.09-.88,1.97-1.97,1.97h-3.61l1.71-2.91c.37-.63,1.05-1.02,1.79-1.02h.11c1.09,0,1.97.88,1.97,1.97ZM1.58,14.17v8.66c0,1.3,1.06,2.36,2.36,2.36h7.09v-11.02H1.58Zm12.6,11.02h7.09c1.3,0,2.36-1.06,2.36-2.36v-8.66h-9.45v11.02Z"/></svg>
          <span class="tooltiptext"><small>A+ Rewards</small></span>
        </span>
        
      </div>
    </div>
  </div>
</template>


